function initialiseTippy() {
  tippy("[data-tippy-content]", {
    arrow: false,
    followCursor: true,
    theme: "shrigley"
  });
}

initialiseTippy();
